import React, { useRef, useState } from "react";
import styled from "styled-components";
import BurgerMenuIcon from "../../components/burgerMenuIcon/BurgerMenuIcon";
import { HeaderLink } from "../../components/MiniComponents";
import logo from '../../assets/img/LH_v02.svg';

const HeaderMobileRoot = styled.div`
    display: none;
    @media (max-width: 768px) {
        display: block;
        border-bottom: solid 1px var(--main-color);
        height: 4.5em;
        position:fixed;
        width: 100%;
        z-index: 3;
        background: var(--color-background);
    }
`;

const Sidebar = styled.div`
    display: none;
    flex-direction: column;
    width: 18em;
    height: 100vh;
    position: fixed;
    z-index: 3;
    background: var(--color-background);
    padding-left: 0em;
    border-right: solid 2px black;
    margin: 0;
`;

const HeaderList = styled.ol`
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 2.5em;
    font-size:1em;
    flex-direction: column;
    padding-left: 0em;
    padding-top: 8em;
    width: 100%;
`;

const HeaderItem = styled.li`
    display: inline-block;
    font-size:1.3em;
    font-variant: all-small-caps;
    width: 100%;
    padding: 1em 0em;
    border-bottom: solid 1px var(--main-color);
 `;

const HeaderLogo = styled.img`
    position: fixed;
    left: 50%;
    margin-left: -5em;
    top: 0.8em;
    width: 10em;
`;

const HeaderMobile = () => {
    const tabs = [
        { id: "ourGame", label: "Notre jeu" },
        { id: "aboutUs", label: "Notre équipe" },
        { id: "contact", label: "Contact" },
        { id: "policy", label: "Legal" },
    ];
    const [tabSelected, setTabSelected] = useState("ourGame");
    const sidebar = useRef(null);
    return (
        <HeaderMobileRoot>
            <BurgerMenuIcon />
            <HeaderLogo src={logo} />
            <Sidebar className="sidebar" ref={sidebar} >
                <HeaderList>
                    {tabs.map((tab) =>
                        <HeaderItem key={tab.id}>
                            <HeaderLink href={"#" + tab.id}
                                selected={tabSelected === tab.id}
                                onClick={(e) => { setTabSelected(tab.id); sidebar.current.classList.remove("open"); document.querySelector(".sidenav").classList.remove("open"); }}>{tab.label}</HeaderLink>
                        </HeaderItem>
                    )}
                </HeaderList>
            </Sidebar>
        </HeaderMobileRoot>
    )
}


export default HeaderMobile;


// WEBPACK FOOTER //
// ./src/pages/HeaderBar/HeaderMobile.jsx